import gatewayService from '@/modules/common/services/gatewayService';

const BASE_ROUTE = '/v3/ai/business_rules';

const fetchRules = async () => {
  const res = await gatewayService.get(BASE_ROUTE);
  return res.data.data.business_rules;
};

const createRule = async (payload) => {
  const res = await gatewayService.post(BASE_ROUTE, payload);
  return res.data.data.business_rule;
};

const updateRule = async (uid, payload) => {
  const res = await gatewayService.put(`${BASE_ROUTE}/${uid}`, payload);
  return res.data.data.business_rule;
};

const deleteRule = async (uid) => {
  await gatewayService.remove(`${BASE_ROUTE}/${uid}`);
};

export default {
  fetchRules,
  createRule,
  updateRule,
  deleteRule,
};
